export const adtRouteDef = [
    {
        path: ':resource/:id/bed-management',
        component: 'BedManagementComponent',
        data: {
            selector: 'app-bed-management'
        }
    },
    {
        path: 'clearance_status',
        component: 'TrackStatusComponent',
        data: {
            selector: 'kx-track-status',
            resource: 'encounter_dischargeClearance'
        }
    },
    {
        path: 'counselling_detail_add/add/counselling',
        component: 'CounsellingComponent',
        data: {
            selector: 'app-counselling',
            resource: 'counselling_detail_add',
            action: 'ADD'
        }
    },
    {
        path: ':resource/:id/modify',
        component: 'CounsellingComponent',
        data: {
            selector: 'app-counselling',
            resource: 'counselling_draft',
            id: 'id',
            action: 'MODIFY'
        }
    },
     {
        path: ':resource/:id/copy_counselling',
        component: 'CounsellingComponent',
        data: {
            selector: 'app-counselling',
            resource: 'counselling_draft',
            id: 'id',
            action: 'MODIFY'
        }
    },
     {
        path: ':resource/:id/copy_counselling_final',
        component: 'CounsellingComponent',
        data: {
            selector: 'app-counselling',
            resource: 'counselling_detail',
            id: 'id',
            action: 'MODIFY'
        }
    },
    {
        path: 'uploadedfile_metadata',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'encounter_uploadedfile_metadeta_tab',
            action: 'IMAGE_VIEWER',
        }
    },
    {
        path: 'clearance_status/:patientType',
        component: 'TrackStatusComponent',
        data: {
            selector: 'kx-track-status',
            resource: 'encounter_dischargeClearance'
        }
    },
    {
        path: ':resource/patient_clearence',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
        }
    },
    {
        path:':uhId/dayCare',
        component:'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',  
            resource: 'encounter_packageMgmt',
            action: 'ADD' 
        }
    },
    {
        path: ':action/:key/emrView',
        component: 'EmrComponent',
        data: {
            selector: 'app-emr',
            resource: 'emr_format',
            viewOnly: 'view'
        }
    },
    {
        path: ':id/encounter_ipAdmission/modify_admit',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'encounter_ipAdmission',
            id: "patient_id",
            action: 'MODIFY'
        }
    },
        {
        path: ':id/encounter_erAdmission/modify_er_admit',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'encounter_erAdmission',
            id: "patient_id",
            action: 'MODIFY'
        }
    },
    {
        path: ':id/encounter_dcAdmission/modify_dc_admit',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'encounter_dcAdmission',
            id: "patient_id",
            action: 'MODIFY'
        }
    },
]    